import Vue from 'vue'
import Router from 'vue-router'
// import home from '@/components/home'
// import serve from '@/components/serve'
// import facilitator from '@/components/facilitator'
// import build from '@/components/build'
// import company from '@/components/company'
// import firehouse from '@/components/firehouse'
// import manage from '@/components/manage'
// import maintenance from '@/components/maintenance'
// import notice from '@/components/notice'
// import particulars from '@/components/particulars'
const _import = require('./_import')

Vue.use(Router)

console.log('process.env.ENV_SERVER', process.env.ENV_SERVER)
const env = process.env.ENV_SERVER
let router = {

}
if (env === 'hp' || env === 'hpnw') {
  router.routes = [
    { path: '/', name: 'home', component: _import('hpComponents/home'), meta: {title: '黄浦区消防支队公示平台'} },
    { path: '/Home', name: 'home', component: _import('hpComponents/home'), meta: {title: '黄浦区消防支队公示平台'} },
    { path: '/serve', name: 'serve', component: _import('hpComponents/serve'), meta: {title: '常用服务-黄浦区消防支队'} },
    { path: '/facilitator', name: 'facilitator', component: _import('hpComponents/facilitator'), meta: {title: '已接入服务商-黄浦区消防支队'} },
    { path: '/build', name: 'build', component: _import('hpComponents/build'), meta: {title: '已接入建筑-黄浦区消防支队'} },
    { path: '/company', name: 'company', component: _import('hpComponents/company'), meta: {title: '已接入重点单位-黄浦区消防支队'} },
    { path: '/firehouse', name: 'firehouse', component: _import('hpComponents/firehouse'), meta: {title: '微型消防站-黄浦区消防支队'} },
    { path: '/manage', name: 'manage', component: _import('hpComponents/manage'), meta: {title: '建筑管理单位-黄浦区消防支队'} },
    { path: '/maintenance', name: 'maintenance', component: _import('hpComponents/maintenance'), meta: {title: '维保单位-黄浦区消防支队'} },
    { path: '/notice', name: 'notice', component: _import('hpComponents/notice'), meta: {title: '维保单位-黄浦区消防支队'} },
    { path: '/particulars/:id', name: 'particulars', component: _import('hpComponents/particulars'), meta: {title: '公告详情-黄浦区消防支队'} },
    { path: '/improvement', name: 'improvement', component: _import('hpComponents/improvement'), meta: {title: '改进通知-黄浦区消防支队'} },
    { path: '/improvedetails/:id', name: 'improvedetails', component: _import('basicComponents/improvedetails'), meta: {title: env === 'ja' ? '改进详情-静安消防蓝盾网' : '改进详情-上海市消防总队'} }
  ]
} else {
  router.routes = [
    { path: '/', name: 'home', component: _import('basicComponents/home'), meta: {title: env === 'ja' ? '静安消防蓝盾网公示平台' : '上海市消防总队公示平台'} },
    { path: '/Home', name: 'home', component: _import('basicComponents/home'), meta: {title: env === 'ja' ? '静安消防蓝盾网公示平台' : '上海市消防总队公示平台'} },
    { path: '/serve', name: 'serve', component: _import('basicComponents/serve'), meta: {title: env === 'ja' ? '常用服务-静安消防蓝盾网' : '常用服务-上海市消防总队'} },
    { path: '/facilitator', name: 'facilitator', component: _import('basicComponents/facilitator'), meta: {title: env === 'ja' ? '已接入服务商-静安消防蓝盾网' : '已接入服务商-上海市消防总队'} },
    { path: '/build', name: 'build', component: _import('basicComponents/build'), meta: {title: env === 'ja' ? '已接入建筑-静安消防蓝盾网' : '已接入建筑-上海市消防总队'} },
    { path: '/company', name: 'company', component: _import('basicComponents/company'), meta: {title: env === 'ja' ? '已接入重点单位-静安消防蓝盾网' : '已接入重点单位-上海市消防总队'} },
    { path: '/firehouse', name: 'firehouse', component: _import('basicComponents/firehouse'), meta: {title: env === 'ja' ? '微型消防站-静安消防蓝盾网' : '微型消防站-上海市消防总队'} },
    { path: '/manage', name: 'manage', component: _import('basicComponents/manage'), meta: {title: env === 'ja' ? '建筑管理单位-静安消防蓝盾网' : '建筑管理单位-上海市消防总队'} },
    { path: '/maintenance', name: 'maintenance', component: _import('basicComponents/maintenance'), meta: {title: env === 'ja' ? '维保单位-静安消防蓝盾网' : '维保单位-上海市消防总队'} },
    { path: '/notice', name: 'notice', component: _import('basicComponents/notice'), meta: {title: env === 'ja' ? '维保单位-静安消防蓝盾网' : '维保单位-上海市消防总队'} },
    { path: '/particulars/:id', name: 'particulars', component: _import('basicComponents/particulars'), meta: {title: env === 'ja' ? '公告详情-静安消防蓝盾网' : '公告详情-上海市消防总队'} },
    { path: '/improvement', name: 'improvement', component: _import('basicComponents/improvement'), meta: {title: env === 'ja' ? '改进通知-静安消防蓝盾网' : '改进通知-上海市消防总队'} },
    { path: '/improvedetails/:id', name: 'improvedetails', component: _import('basicComponents/improvedetails'), meta: {title: env === 'ja' ? '改进详情-静安消防蓝盾网' : '改进详情-上海市消防总队'} }
  ]
}
export default new Router(router);
(window.onresize = window.__setFontSize__ = function () {
  document.documentElement.style.fontSize =
    (Math.min(750, Math.max(document.documentElement.clientWidth, 320)) / 375) *
      13 + 'px'
})()



// WEBPACK FOOTER //
// ./src/router/index.js